import { Reducer } from 'redux'
import { IMonitoringState } from '../states/monitoring.state'
import * as fromActions from '../actions/monitoring.actions'
import * as fromChatActions from '../actions/chat.action'

export const initialState: IMonitoringState = {
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  user: {} as any,
  loading: false,
  selectedItems: {
    all: false,
    add: [],
    discard: [],
    total: 0,
    clear: false,
  },
}

export const reducer: Reducer<IMonitoringState> = (
  state: IMonitoringState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.MONITORING_GET_SUCCESS: {
      const { data: list, total, perPage, sort } = payload
      return {
        ...state,
        list,
        total,
        perPage,
        sort,
        loading: false,
      }
    }
    case fromActions.MONITORING_SET_LOADING: {
      return {
        ...state,
        loading: payload,
      }
    }
    case fromActions.USER_MONITORING_GET:
    case fromActions.USER_MONITORING_DESTROY_MANY:
    case fromActions.USER_MONITORING_UPLOAD:
      return {
        ...state,
        loading: true,
      }
    case fromActions.USER_MONITORING_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case fromActions.USER_MONITORING_GET_SUCCESS:
      return {
        ...state,
        user: payload,
        loading: false,
      }
    case fromChatActions.CREATE_CHAT_MESSAGE_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          conversationId: payload,
        },
      }
    }
    case fromActions.UPDATE_SELECTED_ITEMS: {
      return {
        ...state,
        selectedItems: payload,
      }
    }
    default:
      return state
  }
}
